import React, {useEffect, useMemo, useState} from 'react';
import styled from 'styled-components';
import Modal from '../Modal/Modal';
import {labels} from '../../../util/utils';
import {useDispatch, useSelector} from 'react-redux';
import EllipsesControl from '../EllipsesControl/EllipsesControl';
import {getLinkedDocuments} from '../../../actions/Ares/linkedResponse';
import {getLinkedDocumentsByDocumentId} from '../../../selectors/Ares/selectors';
import ProgressBar from '../BaseComponentWrappers/MotifProgressBar';
import Utility from '../../../../src/util/utilityfunctions';

function SharedActivityRelationships(props) {
	const {engagementId, currentDocument, showRelationshipsModal, modalsize, onHideUnlinkModal} = props;
	const dispatch = useDispatch();
	const [showLoading, setShowLoading] = useState(false);
	const linkedDocuments = useSelector((state) => getLinkedDocumentsByDocumentId(state, currentDocument.id));

	Utility.sortAlphaNumeric(linkedDocuments, 'documentName');

	const isLinkedDocumentsAvailable = useMemo(() => {
		return linkedDocuments && linkedDocuments.length > 0;
	}, [linkedDocuments]);

	useEffect(() => {
		if (!isLinkedDocumentsAvailable) {
			getLinkedDocumentRelationships();
		}
	}, []);

	const getLinkedDocumentRelationships = () => {
		setShowLoading(true);
		dispatch(getLinkedDocuments(engagementId, currentDocument.taskId, currentDocument.id))
			.then(() => {
				setShowLoading(false);
			})
			.catch(() => {
				setShowLoading(false);
			});
	};

	return (
		<Modal
			show={showRelationshipsModal}
			modalsize={modalsize}
			closeTitle={labels.modalCloseTitle}
			showFooter={false}
			title={labels.shareActivityRelationshipsModalTitle}
			modalContainerClass={`sharedActivityRelationshipsModalContainer ${showLoading &&
				'sharedActivityRelationshipsModalContainerLoader'}`}
			onHide={onHideUnlinkModal}
		>
			<StyledSharedActivityRelationships className="StyledSharedActivityRelationships">
				{showLoading && (
					<section className="MotifProgressBarWrapper">
						<ProgressBar className="sharedActivityRelationshipsLoader" isIndeterminate circle hideLabel />
					</section>
				)}
				<section className="sharedActivityRelationshipsInfoWrapper">
					<section className="sharedActivityHeading">{labels.shareActivityWorkspaceHeading}</section>
					<section className="engagementActivityWrapper">
						<section className="engagementActivityHeadingWrapper">
							<section className="engagementHeading">{labels.shareActivityEngagement}</section>
							<section className="activityHeading">{labels.activity}</section>
						</section>
						<section className="engagementActivityContainer customScrollbar">
							{isLinkedDocumentsAvailable &&
								linkedDocuments.map(
									(linkedDocument) =>
										linkedDocument && (
											<section className="engagementActivityContentWrapper">
												<section className="engagementContent">
													<EllipsesControl
														tooltipClass="engagementEllipsesControlContent"
														content={linkedDocument.engagementName}
														tooltip={linkedDocument.engagementName}
														noOfLines={1}
													/>
												</section>
												<section className="activityContent">
													<EllipsesControl
														tooltipClass="engagementEllipsesControlContent"
														content={linkedDocument.documentName}
														tooltip={linkedDocument.documentName}
														noOfLines={1}
													/>
												</section>
											</section>
										)
								)}
						</section>
					</section>
				</section>
			</StyledSharedActivityRelationships>
		</Modal>
	);
}

export default SharedActivityRelationships;

const StyledSharedActivityRelationships = styled.section`
	height: calc(100% - var(--px-8));
	position: relative;
	margin-top: var(--px-8);
	.MotifProgressBarWrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		z-index: 9;
		background: var(--neutrals-00white);
	}
	.sharedActivityRelationshipsInfoWrapper {
		height: 100%;
		display: flex;
		flex-direction: column;
		.sharedActivityHeading {
			font-size: var(--px-16);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
			border-bottom: var(--px-1) solid var(--neutrals-100);
			padding-bottom: var(--px-24);
			margin-bottom: var(--px-24);
		}
		.engagementActivityWrapper {
			border: var(--px-1) solid var(--neutrals-300);
			border-radius: var(--px-8);
			overflow: hidden;
			.engagementActivityHeadingWrapper {
				padding: var(--px-12) var(--px-16);
				background: var(--neutrals-25);
				border-radius: var(--px-8) var(--px-8) 0 0;
				border-bottom: var(--px-1) solid var(--neutrals-200);
				display: flex;
				.engagementHeading {
					font-size: var(--px-14);
					font-weight: 400;
					line-height: var(--px-16);
					color: var(--neutrals-900);
					width: 60%;
				}
				.activityHeading {
					font-size: var(--px-14);
					font-weight: 400;
					line-height: var(--px-16);
					color: var(--neutrals-900);
					padding: 0 var(--px-24) 0 var(--px-40);
					width: 40%;
				}
			}
			.engagementActivityContainer {
				max-height: calc(100% - var(--px-40));
				.engagementActivityContentWrapper {
					display: flex;
					padding: var(--px-12) var(--px-16);
					background: var(--neutrals-00white);
					.engagementContent {
						font-size: var(--px-14);
						font-weight: 300;
						line-height: var(--px-24);
						color: var(--neutrals-900);
						width: 60%;
					}
					.activityContent {
						font-size: var(--px-14);
						font-weight: 300;
						line-height: var(--px-24);
						color: var(--neutrals-900);
						padding: 0 var(--px-24) 0 var(--px-40);
						width: 40%;
					}
					&:nth-child(even) {
						background: var(--neutrals-25);
					}
					&:last-child {
						border: 0;
						border-radius: 0 0 var(--px-8) var(--px-8);
					}
				}
			}
		}
	}
`;
